import {useTranslation} from "@i18n";
import useHelpers from "@hooks/useHelpers";
import stl from "./RecTrendingCars.module.css";

const RecTrendingCars = ({similar }) => {
  const { t } = useTranslation(["web_trend"]);
  const {createUrl} = useHelpers();
  return (
    <>
      <div className={stl.ST_recContainer}>
        <p>
          {t("تصفح أيضاً", {
            ts: "web_trend",
          })}
        </p>
        <div className={stl.ST_recommendations}>
          {similar?.map((item, idx) => {
            return (
              <a
                key={idx}
                className={stl.ST_singleRec}
                href={createUrl(
                  `/trend/${item.perma_link}`
                )}
              >
                {item.h1_tag}
              </a>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default RecTrendingCars;
